export const MAX_FILE_SIZE = 15 * 1024 * 1024

const dataURLtoFile = (dataurl, filename) => {
  const arr = dataurl.split(',')
  const mime = arr[0].match(/:(.*?);/)?.[1]
  const bstr = atob(arr[1])
  let n = bstr.length
  const u8arr = new Uint8Array(n)

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }

  return new File([u8arr], filename, { type: mime })
}

export const sortByAlphaDesc = (a, b) => {
  const aUpper = a.toUpperCase()
  const bUpper = b.toUpperCase()
  if (aUpper < bUpper) return -1
  if (aUpper > bUpper) return 1
  return 0
}

export const moveItemToFront = (array, callback) => {
  const index = array.findIndex(callback)
  if (index !== -1) {
    const item = array.splice(index, 1)[0]
    array.unshift(item)
  }

  return array
}

export const cropImage = async (imageFile) => {
  const fileName = imageFile.name
  return new Promise((resolve) => {
    const image = new Image()
    const fr = new FileReader()
    fr.onload = () => {
      if (fr !== null && typeof fr.result === 'string') {
        image.src = fr.result
      }
    }
    fr.readAsDataURL(imageFile)

    image.onload = () => {
      const width = image.width
      const height = image.height
      const isPortrait = width <= height
      const idealWidth = isPortrait ? width : (height * 4) / 3
      const idealHeight = isPortrait ? (width * 3) / 4 : height
      const cropOnSides = isPortrait ? (height - idealHeight) / 2 : (width - idealWidth) / 2

      // To use entire image in canvas instead of canvas default size, we set the height and width to the ideal dimentions
      const canvas = document.createElement('canvas')
      canvas.width = idealWidth
      canvas.height = idealHeight
      const ctx = canvas.getContext('2d')
      ctx?.drawImage(
        image,
        isPortrait ? 0 : cropOnSides,
        isPortrait ? cropOnSides : 0,
        idealWidth,
        idealHeight,
        0,
        0,
        idealWidth,
        idealHeight
      )

      // Turn content of canvas into a DataURL format that we can use to create a File instance
      let croppedImageFile
      let imageQuality = 0.78 // Works for most images to bring them to their original size
      do {
        const croppedImage64Data = canvas.toDataURL('image/jpeg', imageQuality) // If we don't specify filetype and quality, it turns a 2.7MB file into a 39MB file. This quality is pretty close to the original file size.
        croppedImageFile = dataURLtoFile(croppedImage64Data, fileName)
        imageQuality -= 0.1 // Smaller decrements would mean the user wait longer
      } while (croppedImageFile.size >= MAX_FILE_SIZE)

      resolve(croppedImageFile)
    }
  })
}

export const truncateText = (str, limit) => {
  if (!str) return ''
  let trimmedStr = str
  if (str?.length > limit) {
    trimmedStr = `${str.substring(0, limit)}...`

    if (trimmedStr[limit - 1] === ' ') {
      // if the last character is a space, remove it too
      trimmedStr = `${str.substring(0, limit - 1)}...`
    }
  }
  return trimmedStr
}
